export default "__VITE_ASSET__CxmHs8lB__"